module.exports = __webpack_public_path__ + "assets/965953de24e2d2b2ec05569034bbb1cc.png";